function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.866 8.451v-1.88c-.42.212-.86.394-1.317.532-1.404.427-3.241.659-5.179.659-1.718 0-3.392-.195-4.708-.54A8.17 8.17 0 01.1 6.652L.132 8.47v.013c0 .094.276.514 1.599.921 1.254.383 2.946.596 4.758.596 1.806 0 3.505-.22 4.772-.615 1.323-.413 1.611-.846 1.611-.934h-.006zM11.505 3.636c-1.398.414-3.216.64-5.122.64-1.85 0-3.612-.213-4.972-.608A7.693 7.693 0 01.044 3.14L.07 4.583l.006.527c.49.608 2.828 1.392 6.302 1.392 1.812 0 3.523-.213 4.808-.602 1.355-.414 1.65-.84 1.65-.928 0-.07.037-.144.037-.207h.006V3.104a7.16 7.16 0 01-1.373.532zM11.21.596C9.931.206 8.176 0 6.383 0h-.107c-1.668 0-3.254.188-4.47.533C.508.897.063 1.31.006 1.48A.047.047 0 000 1.505l.013.025c.037.131.407.558 1.755.953 1.248.357 2.89.558 4.62.558 1.788 0 3.48-.207 4.766-.59 1.392-.413 1.705-.846 1.712-.94v-.006c-.007-.094-.32-.508-1.656-.91z"
});

function SvgDatabase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 10",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgDatabase;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/database.svg
// module id = 1302
// module chunks = 10